import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router'
import { i18n } from './i18n'
import { loadFeatures } from './config/features.config'
import App from './App.vue'

import './assets/main.css'

const app = createApp(App)

// Порядок важен: Pinia -> i18n -> Router
app.use(createPinia())
app.use(i18n)
app.use(router)

// Флаги читаем ДО первого рендера: иначе неготовая фича успеет мигнуть на
// экране и исчезнуть. finally, а не then — недоступный конфиг не должен
// оставить пользователя с пустой страницей (loadFeatures и так не бросает).
loadFeatures().finally(() => app.mount('#app'))
